module.exports = __webpack_public_path__ + "img/logo-mini-dark.06a745a0.png";